import EditClientData from "../views/households/EditClientData";

export const EDIT_CLIENT_DATA = {
  path: '/change-client',
  component: EditClientData,
  meta: {noauth: true},
  children: [
    {
      path: ':token',
      name: 'change-client',
      component: EditClientData,
      meta: { noauth: true }
    },
  ]
};
